import React, { useState } from 'react';
import ApiClient from '../ApiClient';
import TwoFactorFormUI from './TwoFactorFormUI';

const StepUpAuth = ({ onVerified, onCancel }) => {
    const [rememberDevice, setRememberDevice] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (finalCode, useRecovery) => {
        setLoading(true);
        setError('');

        try {
            const response = await ApiClient.post(`${process.env.REACT_APP_BASE_URL}/2fa/verify-step-up`, { code: finalCode });
            
            const stepUpToken = response.data.stepUpToken;
            if (rememberDevice) {
                localStorage.setItem('da_stepUpToken', stepUpToken);
                sessionStorage.removeItem('da_stepUpToken');
            } else {
                sessionStorage.setItem('da_stepUpToken', stepUpToken);
                localStorage.removeItem('da_stepUpToken');
            }
            
            onVerified();
        } catch (err) {
            console.error('StepUp Auth Error:', err);
            setError(err.response?.data?.message || 'Verification failed. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex items-center justify-center p-3 sm:p-6 w-full min-h-[calc(100vh-180px)]">
            <div className="bg-white rounded-2xl sm:rounded-3xl shadow-sm border border-slate-200/80 p-5 sm:p-7 w-full max-w-sm mx-auto relative overflow-hidden">
                <TwoFactorFormUI 
                    onSubmit={handleSubmit}
                    onCancel={onCancel}
                    loading={loading}
                    error={error}
                    showRememberMe={true}
                    rememberDevice={rememberDevice}
                    setRememberDevice={setRememberDevice}
                    allowRecovery={false}
                />
            </div>
        </div>
    );
};

export default StepUpAuth;
